export default "__VITE_ASSET__D2clgQG4__"